import { LinearProgress } from "@mui/material";
import { FC } from "react";

import { MuiTopProgressStyled } from "./mui-top-progress.styled";

export const MuiTopProgress: FC = () => {
  return (
    <MuiTopProgressStyled>
      <LinearProgress />
    </MuiTopProgressStyled>
  );
};
